document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("form").forEach(form => {
        /**
         * Initializes event handlers for percentage inputs.
         * Attaches handlers to all enabled, editable percentage inputs.
         */
        const attachPercentageInputHandlers = () => {
            const percentageInputs = form.querySelectorAll('[id*="_percentage"]:not([disabled]):not([readonly])')

            percentageInputs.forEach(percentageInput => {
                percentageInput.addEventListener("keypress", validateKeyPress)
                percentageInput.addEventListener("paste", validatePaste)
            })
        }

        /**
         * Prevents invalid characters from being typed into a percentage input.
         *
         * @param {KeyboardEvent} event - The keyboard event.
         */
        const validateKeyPress = (event) => {
            const {key, target} = event

            const newValue = parseFloat(target.value + key) || -1
            const newValueWithinRange = newValue >= 0 && newValue <= 100

            if (!newValueWithinRange)
                event.preventDefault()
        }

        /**
         * Prevents invalid characters from being pasted into a percentage input.
         *
         * @param {ClipboardEvent} event - The clipboard event.
         */
        const validatePaste = (event) => {
            const {clipboardData, target} = event
            const pastedValue = clipboardData.getData("text")

            const newValue = parseFloat(target.value + key) || -1
            const newValueWithinRange = newValue >= 0 && newValue <= 100

            if (!newValueWithinRange)
                event.preventDefault()
        }

        const observer = new MutationObserver(() => {
            attachPercentageInputHandlers()
        })

        observer.observe(form, {childList: true, subtree: true})

        // Attach handlers to percentage inputs once the DOM is fully loaded
        attachPercentageInputHandlers()
    })
})
